import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ permissions: requiredPermissions, children }) => {
  const storedPermissions = JSON.parse(
    localStorage.getItem("permissions") ?? "[]"
  );

  const hasPermission = requiredPermissions.some((p) =>
    storedPermissions.includes(p)
  );

  if (!hasPermission) {
    return <Navigate to="/session/404" />;
  }

  return children;
};

export default ProtectedRoute;